import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography, { TypographyProps } from '@material-ui/core/Typography';

const Subtitle: React.FC<TypographyProps> = withStyles((theme) => ({
  root: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 'bold',
    color: theme.palette.text.primary,
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(20),
    },
  },
}))(Typography);

export default Subtitle;
